"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const uppercasePattern = /[A-Z]/g;
const msPattern = /^ms-/;
const cache = {};
const toHyphenLower = match => `-${match.toLowerCase()}`;
const hyphenateStyleName = name => {
  if (Object.prototype.hasOwnProperty.call(cache, name)) {
    return cache[name];
  }
  const hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] === msPattern.test(hName) ? `-${hName}` : hName;
};
var _default = exports.default = hyphenateStyleName;